export default __webpack_public_path__ + "static/image07-e47a9a568c6fa44d761d4fec8a473b23.webp";